import clsx from 'clsx';
import React from 'react';

import IconCheckMark from '@components/Images/Rebranding/IconCheckMark';

import type { Benefit } from './interfaces';

interface BenefitsListProps {
  benefits: Benefit[];
  isPro: boolean;
}

const BenefitsList = ({ benefits, isPro }: BenefitsListProps) => (
  <div className="flex flex-col gap-16">
    {benefits.map((benefit, index) => (
      <div
        key={index}
        className={clsx('flex items-center gap-8', {
          'hidden sm:flex': benefit.blank,
        })}
      >
        <IconCheckMark
          className={clsx('h-[16px] w-[24px] shrink-0', {
            'text-pro-gold': isPro,
            'text-primary-magenta': !isPro,
            'min-h-24 opacity-0 ': benefit.blank,
          })}
        />
        {benefit.Icon && <benefit.Icon className="h-[24px] w-auto shrink-0" />}
        {benefit.label && (
          <span className="font-suisse-intl text-button-md font-medium text-grayscale-charcoal">
            {benefit.label}
          </span>
        )}
        {benefit.suffix && (
          <span
            className={clsx(
              'font-suisse-intl text-button-md text-grayscale-charcoal',
              benefit.suffixClassName
            )}
          >
            {benefit.suffix}
          </span>
        )}
      </div>
    ))}
  </div>
);

export default BenefitsList;
